import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Form, Input, Button, message, Row, Col, Typography, Tooltip } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import styles from './Auth.module.css';
import '../../index.css';
import LoginForm from './LoginForm';
import { isTestPublic } from '../../utils/env';

const { Title } = Typography;

const Auth = () => {
  const navigate = useNavigate();
  const [utmParams, setUtmParams] = useState({});
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const params = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'ref'].forEach(
      param => {
        const value = searchParams.get(param);
        if (value) {
          params[param] = value;
        }
      },
    );

    const storedParams = JSON.parse(localStorage.getItem('utmParams') || '{}');
    const combinedParams = { ...storedParams, ...params };

    if (Object.keys(combinedParams).length > 0) {
      setUtmParams(combinedParams);
      localStorage.setItem('utmParams', JSON.stringify(combinedParams));
    }
  }, [location]);

  const handleLogin = () => {
    message.success('ログインに成功しました');
    const from = utmParams.from_page || '/';
    navigate(from);
  };

  return (
    <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
      <Col xs={22} sm={18} md={16} lg={8}>
        <div
          className={styles.authContainer}
          style={{ boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)' }}
        >
          <div className="logo outside">
            <span>Ignite creativity with..</span>
            magicss
          </div>
          <div className={styles.authContent}>
            <LoginForm onFinish={handleLogin} utmParams={utmParams} />
          </div>
          <div style={{ textAlign: 'center', marginTop: '16px' }}>
            {isTestPublic ? (
              <Tooltip title="現在、新規登録を停止しております。近日中に再開を予定しておりますが、その際は公式Xアカウントでご案内させていただきます。">
                <span style={{ color: '#999', cursor: 'not-allowed' }}>
                  新規登録はこちら
                </span>
              </Tooltip>
            ) : (
              <Link to="/register">新規登録はこちら</Link>
            )}
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default Auth;
